import { styled } from "@material-ui/core";
import LogoEstoqueImg from "assets/images/logo-estoque.svg";

export const Logo = styled(props => <img src={LogoEstoqueImg} {...props} />)({
  display: "block"
});
